var isMotionValue = function isMotionValue(value) {
  return value !== null && typeof value === "object" && value.getVelocity;
};
export { isMotionValue };